import { Component } from '@angular/core';

import { Toast } from 'primeng/toast';

@Component({
  selector: 'lib-toast',
  imports: [Toast],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  standalone: true,
})
export class ToastComponent {}

/*export class ToastComponent implements OnInit {
  constructor(private messageService: MessageService) {}

  ngOnInit(): void {
    console.log('ToastComponent - Inicializado, MessageService:', !!this.messageService);

    // Test del toast
    /*
    setTimeout(() => {
      console.log('ToastComponent - Test toast');
      this.messageService.add({
        severity: 'info',
        summary: 'Test',
        detail: 'Toast funcionando correctamente',
        life: 3000,
      });
    }, 2000);
  }
}*/
